import { createReducer } from 'pobble-components/dist/redux-helpers'

const defaultState = {
  selectedCategory: 'ALL',
  selectedGroups: {}
}

const reducer = createReducer(defaultState, {
  CHANGE_SELECTED_CATEGORY: (state, { category }) => ({
    ...state,
    selectedCategory: category
  }),
  CHANGE_GROUP_STATUS: (state, { id, status }) => {
    const selectedGroups = { ...state.selectedGroups }
    status ? (selectedGroups[id] = true) : delete selectedGroups[id]
    return {
      ...state,
      selectedGroups
    }
  }
})

export { reducer, defaultState }
